import React, { useCallback } from 'react';
import { TabShape } from './TabsStateless/TabsStateless';
import ComposableTabs from './ComposableTabs/ComposableTabs';
import ComposableTabsList from './ComposableTabs/ComposableTabsList';
import ComposableTabsTab from './ComposableTabs/ComposableTabsTab';
import useDerivedState from './useDerivedState';

type TabsProps = {
  /** Initial tab selected in login, only use this if you do not use activeTabIndex and onActiveTabIndexChange props */
  defaultActiveTabIndex?: number;
  /** use onActiveTabIndexChange with activeTabIndex */
  onActiveTabIndexChange?: (tabNumber: number) => void;
  /** controlled activeTabIndex. Do not use this with defaultActiveTabIndex */
  activeTabIndex?: number;
  tabs: TabShape[];
};

const Tabs: React.FunctionComponent<TabsProps> = (props) => {
  const {
    tabs,
    defaultActiveTabIndex = 0,
    activeTabIndex,
    onActiveTabIndexChange,
  } = props;
  /* initially and when props.activeTabIndex changes this resets state */
  const [
    internalActiveTab,
    setInternalActiveTab,
  ] = useDerivedState(activeTabIndex ?? defaultActiveTabIndex, [
    activeTabIndex,
  ]);
  const handleActiveTabChange = useCallback(
    (tab: string) => {
      if (onActiveTabIndexChange) {
        onActiveTabIndexChange(Number(tab));
      } else {
        setInternalActiveTab(Number(tab));
      }
    },
    [setInternalActiveTab, onActiveTabIndexChange]
  );
  return (
    <ComposableTabs
      onActiveTabChange={handleActiveTabChange}
      activeTab={`${internalActiveTab}`}
    >
      <ComposableTabsList>
        {tabs.map((item, index) => {
          return (
            <ComposableTabsTab key={`tab-${index}`} tabKey={`${index}`}>
              {item.tabTitle}
            </ComposableTabsTab>
          );
        })}
      </ComposableTabsList>
      <ComposableTabs.Panel>
        {tabs[internalActiveTab]?.content ?? null}
      </ComposableTabs.Panel>
    </ComposableTabs>
  );
};

export default Tabs;
